var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentAuthenticity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-278 370 54 54",
    style: {
      enableBackground: "new -278 370 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n\t.st1{fill:#298BC1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-236.6,393.3c-4.6,0-8.3,3.8-8.3,8.3c0,4.6,3.8,8.3,8.3,8.3s8.3-3.8,8.3-8.3 C-228.3,397.1-232.1,393.3-236.6,393.3z M-235.4,400.7c-1.1,1.5-2.1,3-3,4.6c-0.1,0.1-0.2,0.3-0.3,0.5c-0.3,0.6-0.7,0.9-1.3,0.9 c-0.3,0-0.5,0-0.6-0.1s-0.3-0.2-0.5-0.4c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.3-0.2-0.6-0.4-1.1v-0.1c-0.2-0.5-0.2-0.8-0.2-1 c0-0.3,0.2-0.5,0.5-0.7c0.3-0.3,0.6-0.4,0.9-0.4c0.1,0,0.2,0,0.3,0.1s0.1,0.2,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.5 c0.2,0.5,0.3,0.7,0.4,0.7s0.5-0.5,1.1-1.6c0.6-1,1.2-1.8,1.6-2.5c0.6-0.9,1.1-1.6,1.5-2c0.4-0.5,0.6-0.7,0.9-1 c0.3-0.2,0.5-0.4,0.9-0.5c0.4-0.1,0.8-0.2,1.4-0.2l0.1,0.3C-233.2,397.7-234.3,399.2-235.4,400.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-237.9,412.3v5.5c0,0.3-0.2,0.5-0.5,0.5h-29.8c-0.3,0-0.5-0.3-0.5-0.5v-38.7c0-0.3,0.2-0.5,0.5-0.5h3.7 l1.2,5.1h20.1l1.2-5.1h3.7c0.3,0,0.5,0.3,0.5,0.5v11.5c0.3,0,0.5,0,0.9,0c0.9,0,1.7,0.1,2.6,0.3v-11.7c0-2.2-1.7-3.9-3.8-3.9 h-10.4c-0.8-1.8-2.7-3-4.7-3c-2,0-3.8,1.2-4.7,3h-10.2c-2.1,0-3.8,1.7-3.8,3.9v38.6c-0.1,2.2,1.6,4,3.8,4h29.8 c2.1,0,3.8-1.7,3.8-3.9V412c-0.8,0.2-1.6,0.3-2.6,0.3C-237.4,412.3-237.6,412.3-237.9,412.3z M-253.3,374.1c0.9,0,1.8,0.5,2.4,1.1 h-4.9C-255.1,374.6-254.2,374.1-253.3,374.1z M-244.7,378.6l-0.6,2.6h-15.9l-0.6-2.6H-244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-263.6,390.7v2.4h19.6c0.5-0.4,0.9-0.7,1.4-1v-1.4H-263.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-263.6,403h15.8c-0.1-0.5-0.1-1-0.1-1.5c0-0.3,0-0.6,0-0.9h-15.7V403z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-263.6,412.8h21v-2c-0.2-0.1-0.5-0.3-0.6-0.4h-20.3V412.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAuthenticity);
export default __webpack_public_path__ + "static/media/documentAuthenticity.e2f903e22c539a59ab5c9877ae0c2a07.svg";
export { ForwardRef as ReactComponent };